'use client';

import { cn } from '@/lib/utils';
import { SectionHeader } from '@/components/common/section-header';
import { SectionCard } from '@/components/common/section-card';

interface AboutUsCardProps {
  label: string;
  title: string;
  description: string | string[];
  children?: React.ReactNode;
  className?: string;
}

export function AboutUsCard({ label, title, description, children, className }: AboutUsCardProps) {
  const descriptions = Array.isArray(description) ? description : [description];

  return (
    <SectionCard className={className} withGradient>
      <SectionHeader
        label={label}
        title={title}
      />
      <div className='space-y-4'>
        {descriptions.map((desc, index) => (
          <p key={index} className='text-brand-violet-100 text-base font-normal leading-relaxed whitespace-pre-line'>
            {desc}
          </p>
        ))}
      </div>
      {children}
    </SectionCard>
  );
}
